import src from "IMAGE";
export default { src, width: 250, height: 141, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
